import type { NftMetadata } from "@stonkland/protocol/api-types";

type BrokerTraitPanelProps = {
  metadata?: NftMetadata;
  title?: string;
};

export function BrokerTraitPanel({
  metadata,
  title = "FULL GENERATIVE ART RECIPE",
}: BrokerTraitPanelProps) {
  if (!metadata) {
    return <div className="empty-state trait-empty">Trait metadata unavailable.</div>;
  }

  const rarity = new Map(
    metadata.rarity.attributes.map((attribute) => [
      `${attribute.traitType}:${attribute.value}`,
      attribute,
    ]),
  );

  return (
    <section className="trait-panel" aria-label={`${metadata.name} traits`}>
      <div className="trait-panel-head">
        <span>{title}</span>
        <strong>RARITY SCORE {metadata.rarity.score.toFixed(2)}</strong>
      </div>
      <div className="trait-grid">
        {metadata.attributes.map((attribute) => {
          const frequency = rarity.get(
            `${attribute.trait_type}:${attribute.value}`,
          );
          return (
            <span key={`${attribute.trait_type}:${attribute.value}`}>
              <small>{attribute.trait_type}</small>
              <b>{attribute.value}</b>
              <em>
                {frequency
                  ? `${frequency.count.toLocaleString("en-US")} / ${metadata.rarity.collectionSize.toLocaleString("en-US")} · ${(frequency.frequencyBps / 100).toFixed(2)}%`
                  : "UNRANKED"}
              </em>
            </span>
          );
        })}
      </div>
    </section>
  );
}
